import { render, staticRenderFns } from "./iqView.vue?vue&type=template&id=155745e2&scoped=true&"
import script from "./iqView.vue?vue&type=script&lang=js&"
export * from "./iqView.vue?vue&type=script&lang=js&"
import style0 from "./iqView.vue?vue&type=style&index=0&id=155745e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155745e2",
  null
  
)

component.options.__file = "iqView.vue"
export default component.exports